import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { SettingsSidebar } from "components/Settings/SettingsSidebar";
import { ProfileSection } from "components/Settings/ProfileSection";
import { CompanySection } from "components/Settings/CompanySection";
import { ProjectsSection } from "components/Settings/ProjectsSection";
import { BillingSection } from "components/Settings/BillingSection";
import { SecuritySection } from "components/Settings/SecuritySection";
import { NotificationsSection } from "components/Settings/NotificationsSection";
import { SupportSection } from "components/Settings/SupportSection";
import { LegalSection } from "components/Settings/LegalSection";
import { DangerZoneSection } from "components/Settings/DangerZoneSection";

const Settings = () => {
    const [searchParams, setSearchParams] = useSearchParams();
    const initialSection = searchParams.get("section") || "profile";
    const [activeSection, setActiveSection] = useState(initialSection);

    const handleSectionChange = (section) => {
        setActiveSection(section);
        setSearchParams({ section });
    };

    const renderSection = () => {
        switch (activeSection) {
            case "profile":
                return <ProfileSection />;
            case "company":
                return <CompanySection />;
            case "projects":
                return <ProjectsSection />;
            case "billing":
                return <BillingSection />;
            case "security":
                return <SecuritySection />;
            case "notifications":
                return <NotificationsSection />;
            case "support":
                return <SupportSection />;
            case "legal":
                return <LegalSection />;
            case "danger":
                return <DangerZoneSection />;
            default:
                return <ProfileSection />;
        }
    };

    return (
        <div className="h-[92vh] w-[85%] bg-background mx-auto px-6 pt-6 pb-0">
            <div className="flex flex-row gap-12 h-full">
                <SettingsSidebar
                    activeSection={activeSection}
                    onSectionChange={handleSectionChange}
                />
                <div className="flex flex-col w-[70%] h-full overflow-y-scroll pb-2" style={{
                    scrollbarWidth: "none",
                }}>
                    {renderSection()}
                </div>
            </div>
        </div>

    );
};

export default Settings;
